import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import {
  PractitionerProfileCard,
  PractitionerActivityCard,
  PractitionerControlCard,
} from '../../../containers/Cards/Practitioner';
import PractitionerProvider from '../../../containers/Providers/Practitioner';
import OrganizationProvider from '../../../containers/Providers/Organizations';
import { RouteComponentProps, withRouter } from 'react-router';

const PractitionerView = ({
  match,
}: RouteComponentProps<{ organizationId: string; practitionerId: string }>) => (
  <OrganizationProvider organizationId={match.params.organizationId}>
    <PractitionerProvider practitionerId={match.params.practitionerId}>
      <Fade>
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <PractitionerProfileCard />
            </Col>
            <Col>
              <Row noGutters className="mb-3">
                <Col>
                  <PractitionerControlCard />
                </Col>
              </Row>
              <Row noGutters>
                <Col>
                  <PractitionerActivityCard />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Fade>
    </PractitionerProvider>
  </OrganizationProvider>
);
export default withRouter(PractitionerView);
